<template lang="">
  <div class="mains">
    <div class="container">
      <div class="header_title">统计看板</div>
      <div class="top">
        <div class="top_div top_01">
          <span class="top_title">分发量</span>
          <div class="top_center">
            <div class="top_item">
              <span class="top_item_title"> 今日 </span>
              <span class="top_item_value">
                {{ sales.day || "0" }}
              </span>
            </div>

            <div class="top_item">
              <span class="top_item_title"> 本月 </span>
              <span class="top_item_value">
                {{ sales.month || "0" }}
              </span>
            </div>

            <div class="top_item">
              <span class="top_item_title"> 本年 </span>
              <span class="top_item_value">
                {{ sales.year || "0" }}
              </span>
            </div>
          </div>
        </div>

        <div class="top_div top_02">
          <span class="top_title">客户量</span>
          <div class="top_center">
            <div class="top_item">
              <span class="top_item_title"> 今日新增 </span>
              <span class="top_item_value">
                {{ customer.day || "0" }}
              </span>
            </div>

            <div class="top_item">
              <span class="top_item_title"> 本月新增 </span>
              <span class="top_item_value">
                {{ customer.month || "0" }}
              </span>
            </div>

            <div class="top_item">
              <span class="top_item_title"> 本年新增 </span>
              <span class="top_item_value">
                {{ customer.year || "0" }}
              </span>
            </div>
          </div>
        </div>

        <div class="top_div top_01">
          <span class="top_title">产品量</span>
          <div class="top_center">
            <div class="top_item">
              <span class="top_item_title"> 今日新增 </span>
              <span class="top_item_value">
                {{ products.day || "0" }}
              </span>
            </div>

            <div class="top_item">
              <span class="top_item_title"> 本月新增 </span>
              <span class="top_item_value">
                {{ products.month || "0" }}
              </span>
            </div>

            <div class="top_item">
              <span class="top_item_title"> 本年新增 </span>
              <span class="top_item_value">
                {{ products.year || "0" }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- <keep-alive> -->
      <div class="containers">
        <div class="item">
          <h2>每日分发量(本月)</h2>
          <div
            :id="myChart"
            style="width: calc(100vw - 265px); height: 500px"
          ></div>
        </div>
      </div>
      <!-- </keep-alive> -->
      <!-- <keep-alive> -->
      <div class="containers">
        <div class="item">
          <h2>产品销量(全部)</h2>
          <div
            :id="myChart1"
            style="width: calc(50vw - 155px); height: 500px"
          ></div>
        </div>
        
        <div class="item">
          <h2>销售客户(全部)</h2>
          <div
            :id="myChart2"
            style="width: calc(50vw - 155px); height: 500px"
          ></div>
        </div>
      </div>
      <!-- </keep-alive> -->
    </div>
  </div>
</template>
<script>
import {
  getDispenseStice,
  getCustomer,
  getProducts,
  getEveryday,
  getMarket,
  getproductMarket,
} from "@/api/index";
import * as echarts from "echarts";

export default {
  data() {
    return {
      columns: "",
      sales: {
        day: "",
        month: "",
        year: "",
      },
      customer: {
        day: "",
        month: "",
        year: "",
      },
      products: {
        day: "",
        month: "",
        year: "",
      },
      EverydayData: {
        title: [],
        data: [],
      },
      Markets: {
        title: [],
        data: [],
      },
      productMarket: {
        title: [],
        data: [],
      },
      myChart: 0,
      myChart1: 0,
      myChart2: 0,
    };
  },
  created() {
    // let control = this.$store.state.control;
  },
  mounted() {
    // 随机id防止图表缓存
    this.myChart = Math.random();
    this.myChart1 = Math.random();
    this.myChart2 = Math.random();

    this.getCustomers();
    this.getDispenseStices();
    this.getProductspro();
    this.getEverydays();
    this.getMarkets();
    this.getproductMarkets();
  },
  methods: {
    setOptions1(chart, captions, values) {
      // 绘制图表

      var max = Math.ceil(this.calMax([values]) / 100) * 100;

      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
          position: function (point, params, dom, rect, size) {
            // 提示框位置
            let x = 0;
            let y = 0;
            if (point[0] + size.contentSize[0] + 10 > size.viewSize[0]) {
              x = point[0] - size.contentSize[0] - 10;
            } else {
              x = point[0] + 10;
            }
            if (point[1] + size.contentSize[1] + 10 > size.viewSize[1]) {
              y = point[1] - size.contentSize[1] - 10;
            } else {
              y = point[1] + 10;
            }
            return [x, y];
          },
          formatter: (params) => {
            const { name, data } = params[0];
            return `
            <div style="font-size: 14px;font-family: Source Han Sans CN-Medium;font-weight: 500;color: #FFFFFF;margin-bottom:12px;">${name}</div>
            <div style="font-size: 14px;font-family: Source Han Sans CN-Medium;font-weight: 500;color: #FFFFFF;margin-bottom:4px;">销售：${data}</div>`;
          },
          extraCssText:
            "opacity: 0.8;background-color:#050F1B;padding:16px;box-shadow: 1px 6px 15px 1px rgba(0,0,0,0.13);border-radius: 4px;filter: blur(undefinedpx);border:none;",
        },
        grid: {
          top: "10%", //上边距
          right: "20", //右边距
          left: "20", //左边距
          bottom: "10%", //下边距
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: captions,
          axisTick: {
            show: false, //隐藏X轴刻度
          },
          axisLine: {
            lineStyle: {
              color: "#CCCCCC",
            },
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "rgba(0,0,0,0.65)",
              fontSize: 14,
              fontFamily: "Source Han Sans CN-Regular",
            },
          },
        },
        yAxis: [
          {
            type: "value",
            name: "单位：项",
            min: 0,
            max: max,
            interval: max / 5, //  平均分为5份
            splitNumber: 5,
            nameTextStyle: {
              color: "rgba(0,0,0,0.65)",
              fontSize: 14,
              fontFamily: "Source Han Sans CN-Regular",
              align: "left",
              verticalAlign: "center",
            },
            axisLabel: {
              color: "rgba(0,0,0,0.65)",
              textStyle: {
                fontSize: 14,
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(223, 223, 223, 1)",
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                color: "rgba(223, 223, 223, 1)",
                type: "dashed",
              },
            },
          },
        ],
        series: [
          {
            type: "bar",
            data: values,
            itemStyle: {
              color: "#5B8FF9",
            },
            barWidth: 16,
          },
        ],
      };
      option && chart.setOption(option);
    },
    setOptions2(chart, captions, values) {
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
          position: function (point, params, dom, rect, size) {
            // 提示框位置
            let x = 0;
            let y = 0;
            if (point[0] + size.contentSize[0] + 10 > size.viewSize[0]) {
              x = point[0] - size.contentSize[0] - 10;
            } else {
              x = point[0] + 10;
            }
            if (point[1] + size.contentSize[1] + 10 > size.viewSize[1]) {
              y = point[1] - size.contentSize[1] - 10;
            } else {
              y = point[1] + 10;
            }
            return [x, y];
          },
          formatter: (params) => {
            // console.log(params);
            const { name, data } = params[0];
            return `
            <div style="font-size: 14px;font-family: Source Han Sans CN-Medium;font-weight: 500;color: #FFFFFF;margin-bottom:12px;">${name}</div>
            <div style="font-size: 14px;font-family: Source Han Sans CN-Medium;font-weight: 500;color: #FFFFFF;margin-bottom:4px;">发售：${data} </div>
         `;
          },
          extraCssText:
            "opacity: 0.8;background-color:#050F1B;padding:16px;box-shadow: 1px 6px 15px 1px rgba(0,0,0,0.13);border-radius: 4px;filter: blur(undefinedpx);border:none;",
        },
        grid: {
          top: "10%", //上边距
          right: "20", //右边距
          left: "20", //左边距
          bottom: "10%", //下边距
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: captions,
          axisTick: {
            show: false, //隐藏X轴刻度
          },
          axisLine: {
            lineStyle: {
              color: "#CCCCCC",
            },
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "rgba(0,0,0,0.65)",
              fontSize: 14,
              fontFamily: "Source Han Sans CN-Regular",
            },
          },
        },
        yAxis: [
          {
            type: "value",
            name: "单位：件",
            nameTextStyle: {
              color: "rgba(0,0,0,0.65)",
              fontSize: 14,
              fontFamily: "Source Han Sans CN-Regular",
              align: "left",
              verticalAlign: "center",
            },
            axisLabel: {
              color: "rgba(0,0,0,0.65)",
              textStyle: {
                fontSize: 14,
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(223, 223, 223, 1)",
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                color: "rgba(223, 223, 223, 1)",
                type: "dashed",
              },
            },
          },
        ],
        series: [
          {
            type: "line",
            data: values,
            symbolSize: 8, //标记的大小
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "rgba(116,160,249,0.15)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(29,63,120,0)", // 100% 处的颜色
                  },
                ],
                false
              ),
            },
            lineStyle: {
              color: "#5B8FF9",
              width: 3,
              shadowColor: "rgba(26,117,218,0.17)", //设置折线阴影
              shadowBlur: 5,
              shadowOffsetY: 9,
            },
            itemStyle: {
              //折线拐点标志的样式
              color: "#5B8FF9",
              borderColor: "#5B8FF9",
              borderWidth: 5,
            },
            smooth: 0.4,
            emphasis: {
              scale: 1.5,
            },
          },
        ],
      };
      option && chart.setOption(option);
    },
    setOptions3(chart, captions, values) {
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          top: "15%",
          right: "3%",
          left: "10%",
          bottom: "12%",
        },
        xAxis: [
          {
            type: "category",
            data: captions,
            axisLine: {
              lineStyle: {
                color: "#7e9fb6",
              },
            },
            axisLabel: {
              margin: 10,
              color: "#7e9fb6",
              textStyle: {
                fontSize: 14,
              },
            },
          },
        ],
        yAxis: [
          {
            name: "单位：个",
            axisLabel: {
              color: "#7e9fb6",
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#7e9fb6",
              },
            },
            splitLine: {
              lineStyle: {
                color: "rgba(126,159,182,0.12)",
              },
            },
          },
        ],
        series: [
          {
            type: "bar",
            data: values,
            barWidth: "20px",
            itemStyle: {
              color: "#6EC3C9",
            },
          },
        ],
      };
      option && chart.setOption(option);
    },
    calMax(arr) {
      let max = 0;
      arr.forEach((el) => {
        el.forEach((el1) => {
          if (!(el1 === undefined || el1 === "")) {
            if (max < el1) {
              max = el1;
            }
          }
        });
      });
      let maxint = Math.ceil(max / 9.5);
      //不让最高的值超过最上面的刻度
      let maxval = maxint * 10;
      //让显示的刻度是整数
      return maxval;
    },
    // 获取销售量
    getDispenseStices() {
      getDispenseStice({}).then((res) => {
        this.sales.day = res.day;
        this.sales.month = res.month;
        this.sales.year = res.year;
      });
    },
    // 获取客户量
    getCustomers() {
      getCustomer({}).then((res) => {
        this.customer.day = res.day;
        this.customer.month = res.month;
        this.customer.year = res.year;
      });
    },
    // 获取产品量
    getProductspro() {
      getProducts({}).then((res) => {
        this.products.day = res.day;
        this.products.month = res.month;
        this.products.year = res.year;
      });
    },
    // 获取每日销量
    getEverydays() {
      getEveryday({}).then((res) => {
        this.EverydayData.title = res.title;
        this.EverydayData.data = res.data;

        var chart = echarts.init(document.getElementById(this.myChart)); //注意此处
        this.setOptions2(
          chart,
          this.EverydayData.title,
          this.EverydayData.data
        );
      });
    },

    // 获取客户销量
    getMarkets() {
      getMarket({}).then((res) => {
        this.Markets.title = res.title;
        this.Markets.data = res.data;

        var chart = echarts.init(document.getElementById(this.myChart2)); //注意此处
        this.setOptions3(chart, this.Markets.title, this.Markets.data);
      });
    },

    //获取产品销量
    getproductMarkets() {
      getproductMarket({}).then((res) => {
        this.productMarket.title = res.title;
        this.productMarket.data = res.data;

        var chart1 = echarts.init(document.getElementById(this.myChart1)); //注意此处
        this.setOptions3(
          chart1,
          this.productMarket.title,
          this.productMarket.data
        );
      });
    },
  },
};
</script>
<style scoped >
.top {
  width: 100%;
  background: white;
  padding: 15px;
  display: flex;
  flex-direction: row;
}

.select {
  margin-left: 10px;
}

.containers {
  width: auto;
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  min-width: 1015px;
}

.containers>.item {
  margin-right: 15px;
  width: auto;
  padding: 15px;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mains {
  overflow-y: auto;
  min-width: 1015px;
  width: 100%;
  height: 100%;
}

.top_01 {
  background: url("@/assets/images/1.png");
}

.top_02 {
  background: url("@/assets/images/2.png");
}

.top_div {
  min-width: 250px;
  padding: 10px;
  width: 32.3%;
  margin-right: 1%;
  height: 150px;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.top_title {
  line-height: 40px;
  color: white;
  font-weight: bold;
  font-size: 20px;
}

.top_center {
  width: 100%;
  height: calc(100% - 40px);
  display: flex;
  flex-direction: row;
  align-items: center;
}

.top_item {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  color: white;
}

.top_item_title {
  font-size: 16px;
  font-weight: bold;
}

.top_item_value {
  font-size: 18px;
  font-weight: bold;
}

.main {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
